import dynamic from "next/dynamic";

import Variables from "../../../variables/variables.json";

import Section from "../../../components/Section";
import SectionLayout from "../_sectionLayout";

export default function Kontakt(props) {
  let Miasto = props.miasto;
  let Podatek = props.podatek;

  const CityKontaktPL = dynamic(() =>
    import(
      "../../../content/" +
        Variables.miasta[Miasto].name.url +
        "/kontakt/kontakt_pl.mdx"
    )
  );

  return (
    <SectionLayout miasto={Miasto} podatek={Podatek}>
      <Section center mdx>
        <CityKontaktPL />
      </Section>
    </SectionLayout>
  );
}
